var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 93,
    viewBox: "0 0 92 93",
    width: 92,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.4728 44.7205s18.628-7.8458 25.0885-10.6085c2.4766-1.105 10.8753-4.6412 10.8753-4.6412s3.8764-1.547 3.5533 2.2101c-.1077 1.5471-.9691 6.9618-1.8304 12.8186-1.2922 8.2879-2.692 17.3493-2.692 17.3493s-.2153 2.5417-2.0458 2.9837-4.8455-1.547-5.3838-1.9892c-.4308-.3314-8.0757-5.3042-10.8753-7.7353-.7538-.663-1.6151-1.989.1076-3.5361 3.8764-3.6467 8.5064-8.1774 11.306-11.0505 1.2922-1.3261 2.5842-4.4203-2.7996-.6631-7.6449 5.4148-15.1822 10.498-15.1822 10.498s-1.7229 1.105-4.9531.1104c-3.2304-.9944-6.9991-2.3205-6.9991-2.3205s-2.584-1.6576 1.8306-3.4257z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.df1d53be0304ca05f9a2ace9d5584584.svg";
export { ForwardRef as ReactComponent };